import {fulfilledState, pendingState, rejectedState, resError} from "@helpers";
import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import VideosService from "@services/VideosService";

export const getEdit = createAsyncThunk(
  "video/edit",
  async ({id}, {rejectWithValue}) => {
    try {
      const response = await VideosService.viewVideo({id});

      return response.data;
    } catch (err) {
      return rejectWithValue(resError(err));
    }
  },
);

export const update = createAsyncThunk(
  "video/update",
  async ({id, video}, {rejectWithValue}) => {
    try {
      const response = await VideosService.updateVideo({id, video});

      return response.data;
    } catch (err) {
      return rejectWithValue(resError(err));
    }
  },
);

const initialState = {
  target: null,
  initialTarget: null,
  isChanged: false,
  errors: null,
  error: "",
  status: "",
};

const editVideoSlice = createSlice({
  name: "edit-video",
  initialState,
  reducers: {
    setTarget(state, action) {
      state.target = action.payload;
      state.isChanged = true;
    },
    setInitialTarget(state, action) {
      state.initialTarget = action.payload;
    },
    setIsChanged(state, action) {
      state.isChanged = action.payload;
    },
    setErrors(state, action) {
      state.errors = action.payload;
    },
    setError(state, action) {
      state.error = action.payload;
    },
    setStatus(state, action) {
      state.status = action.payload;
    },
    clearEdit() {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getEdit.pending, (state) => {
        pendingState(state);
      })
      .addCase(getEdit.fulfilled, (state, action) => {
        state.target = action.payload;
        state.initialTarget = action.payload;
        fulfilledState(state);
      })
      .addCase(getEdit.rejected, (state, action) => {
        rejectedState(state, action);
      })

      .addCase(update.pending, (state) => {
        pendingState(state);
      })
      .addCase(update.fulfilled, (state, action) => {
        state.target = action.payload;
        state.initialTarget = action.payload;
        fulfilledState(state);
      })
      .addCase(update.rejected, (state, action) => {
        rejectedState(state, action);
      });
  },
});

export const {
  setTarget,
  setInitialTarget,
  setIsChanged,
  setErrors,
  setError,
  setStatus,
  clearEdit,
} = editVideoSlice.actions;
export default editVideoSlice.reducer;
